import message from "../../../messages/gift";

const validateMinAmount = (minAmount) => {
  if (minAmount < parseInt(process.env.REACT_APP_AT_LEAST_AMOUNT_CHARGE)) {
    return message.AMOUNT_IS_LESS;
  }

  return true;
};

const validateMaxAmount = (minAmount, maxAmount) => {
  if (minAmount >= maxAmount) {
    return message.MAX_AMOUNT_IS_LOWER_THAN_MIN_AMOUNT;
  }

  return true;
};

const validateFormAddGift = (data) => {
  const resValidateMinAmount = validateMinAmount(data.min_amount);
  if (resValidateMinAmount != true) {
    return resValidateMinAmount;
  }

  const resValidateMaxAmount = validateMaxAmount(
    data.min_amount,
    data.max_amount
  );
  if (resValidateMaxAmount != true) {
    return resValidateMaxAmount;
  }

  return true;
};

export default validateFormAddGift;
